var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-dropdown', {
    attrs: {
      "variant": "link",
      "block": "",
      "right": "",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('span', {
          staticClass: "dropdown-toggle d-letter-spacing",
          attrs: {
            "id": "sidebarIcon",
            "href": "#",
            "role": "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }
        }, [_c('div', {
          staticClass: "account-body tw-block tw-text-white md:tw-text-inherit mr-4"
        }, [_c('h3', {
          staticClass: "mb-0 bold"
        }, [!_vm.name ? [_c('b-skeleton', {
          attrs: {
            "animation": "fade",
            "width": "140px"
          }
        })] : [_vm._v("Welcome, " + _vm._s(_vm.name))]], 2), !_vm.name ? _c('b-skeleton', {
          attrs: {
            "animation": "fade",
            "width": "100px"
          }
        }) : _c('small', {
          staticClass: "mb-0"
        }, [_vm._v("Winona Admin")])], 1), _c('b-icon', {
          staticClass: "tw-text-white",
          attrs: {
            "icon": "caret-down-fill",
            "font-scale": "0.75"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_vm._l(_vm.navList, function (list, i) {
    return _c('b-dropdown-item', {
      key: i + '3',
      staticClass: "d-md-none",
      attrs: {
        "to": '/' + list.link,
        "exact": "",
        "exact-active-class": "active"
      }
    }, [_vm._v(" " + _vm._s(list.name) + " "), list.hasBadge && _vm.unreadMessagesCount > 0 ? _c('b-badge', {
      staticClass: "ml-2 !tw-bg-[#984422] !text-[#ffecca]",
      attrs: {
        "pill": ""
      }
    }, [_vm._v(" " + _vm._s(_vm.unreadMessagesCount) + " ")]) : _vm._e()], 1);
  }), _c('b-dropdown-item', {
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v(" Logout ")])], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };